import { Box, Typography } from "@mui/material";

interface BoxLogoProps {
  fontSize?: number;
}

export const BoxLogo: React.FC<BoxLogoProps> = ({ fontSize }) => {

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        m: 0,
        p: 0,
      }}
    >
      <Typography
        sx={{
          fontSize: `${fontSize}px`,
          fontWeight: 700,
          color: "primary.main",
          m: 0,
          p: 0,
          lineHeight: 1,
          letterSpacing: 0,
        }}
      >
        Box
      </Typography>
    </Box>
  );
};
